<template>
  <div id="app">
    <b-modal id="alertModal" hide-footer hide-header centered>
      <b-btn-close aria-label="Close" content="x" @click="$bvModal.hide('alertModal')"></b-btn-close>
      <!-- <button type="button" class="btn-close" data-bs-dismiss="alertModal" aria-label="Close"></button> -->
      <div class="p-4 p-lg-5">
        <a href="https://www.anzen.mofa.go.jp/covid19/pdfhistory_world.html" target="_blank">
          <div class="pb-3">海外旅行はいつから再開するの？現地の最新状況は？</div>
          <div class="pb-3">
            など新型コロナウイルス（COVID-19)に関するお問い合わせを多くいただいております。まだまだ海外旅行は難しい時期が続きますが、日々変わっていく現地の情報を次のご旅行選びにお役立ていただけると幸いです。</div>
          <strong>最新の情報は外務省のホームページをご確認ください。</strong>
          日本からの渡航者・日本人に対する各国・地域の入国制限措置及び入国後の行動制限（外部リンク- 外務省
        </a>
      </div>
    </b-modal>
    <b-modal id="waitModal" centered no-close-on-esc no-close-on-backdrop hide-header hide-footer>
      <div class="my-5 mx-3 text-center">
        <h1>
          <b-icon class="my-2" icon="hourglass-bottom" animation="spin-pulse"></b-icon>
          <!-- <font-awesome-icon icon="fa-solid fa-spinner" class="my-2 fa-spin-pulse"></font-awesome-icon> -->
        </h1>
        請稍候
      </div>
    </b-modal>

    <!-- Navbar -->
    <NavbarPart v-if="!$route.meta.hideNavFooter" />
    <!-- View -->
    <router-view />
    <!-- Footer -->
    <FooterPart :key="$route.fullPath" v-if="!$route.meta.hideNavFooter" />
    <!-- 因為頁面的聯絡人及SEO設定放在footer，所以要加KEY讓每次換頁都重整footer，取得正確資料 -->

    <!-- 回頂部 -->
    <div class="back_top" title="回頂部" @click="scrollTop" v-if="!$route.meta.hideNavFooter">
      <b-icon-chevron-up></b-icon-chevron-up>
    </div>
  </div>
</template>

<script>
import FooterPart from '@/components/FooterPart.vue'
import NavbarPart from '@/components/NavBar.vue'

export default {
  metaInfo: {
    title: '明日之星旅行社：跟團旅遊、國內旅遊、包團、包車、訂房、自由行'
    // titleTemplate: '%s | 明日之星旅行社'
  },
  components: {
    FooterPart,
    NavbarPart
  },
  data() {
    return {
      currentRoute: this.$route.path // 當前路由
    }
  },
  methods: {
    disableRightClick(event) {
      event.preventDefault()
    },
    disableSelection() {
      document.body.style.userSelect = 'none'
    },
    enableSelection() {
      document.body.style.userSelect = ''
    },
    handleRouteChange(newPath) {
      if (newPath.startsWith('/tour/')) {
        // 禁用右鍵和反白
        window.addEventListener('contextmenu', this.disableRightClick)
        this.disableSelection()
      } else {
        // 恢復正常
        window.removeEventListener('contextmenu', this.disableRightClick)
        this.enableSelection()
      }
    }
  },
  watch: {
    '$route.path'(newPath) {
      this.handleRouteChange(newPath)
    }
  },
  mounted() {
    // 初次加載頁面時檢查路由
    this.handleRouteChange(this.$route.path)

    // 確保初始化時路由處於正確狀態
    if (this.$route.path.startsWith('/tour/')) {
      window.addEventListener('contextmenu', this.disableRightClick)
      this.disableSelection()
    }
  },
  async created() {
    // console.log('app')
    // 檢查IP，IP為台北公司時，才顯示管理員登入鈕
    const res = await this.api.get('https://api.ipify.org?format=json')
    // console.log(res.data.ip)
    const ip = res.data.ip
    if (ip === '218.32.239.89' || ip === '218.32.239.91') {
      this.$store.commit('ipIsAdmin', true)
      // console.log('ipIsAdmin')
    } else this.$store.commit('ipIsAdmin', false)
  }
}
</script>

<style lang="scss">
.modal-open {
  padding-right: 17px;
  // overflow: scroll !important;
}

#app {
  a:hover {
    text-decoration: none;
  }
}

#alertModal___BV_modal_content_ {
  border-radius: 0;
  border: none;
  line-height: 1.7rem;

  a {
    color: #721c24;
    text-decoration: none;
  }
}
</style>
